var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MethodButtonBase',{scopedSlots:_vm._u([{key:"slot1",fn:function(){return [_c('PtIdIcon',{class:_vm.$style.icon})]},proxy:true},{key:"slot2",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('id-card'))+" ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }